import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { combineLatest, Subscription, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { ActionService } from 'src/app/core/services/action.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { RouteService } from 'src/app/core/services/route.service';
import { LoadFormSavedFields, Reset, SyncData } from 'src/app/core/state/_actions/form.actions';
import * as moment from 'moment';
import {
  Column,
  SyncDataResponse,
  TabData,
} from 'src/app/core/state/_models/form.model';
import { OpTypes } from 'src/app/core/state/_models/general.model';
import { getApplicationData } from 'src/app/core/state/_selectors/application.selector';
import {
  getFormOperations,
  getformSavedfields,
  getformSavedfieldsLoading,
  getSyncData,
  getSyncError
} from 'src/app/core/state/_selectors/form.selector';
import {
  alertPresets,
  AlertService,
  ToastTypes,
} from 'src/app/shared/services/alert.service';
import { SubSink } from 'subsink';
import { SweetAlertOptions } from 'sweetalert2';
import { createdbyRegex, datecreatedRegex, datemodifiedRegex, modifiedbyRegex } from '../datatable.constants';
import { ErrorComponent } from './error/error.component';
import { DROPDOWN_VALUE_PLACEHOLDER } from 'src/app/shared/constants';

@Component({
  selector: 'app-bulk-update',
  templateUrl: './bulk-update.component.html',
  styleUrls: ['./bulk-update.component.scss'],
})
export class BulkUpdateComponent implements OnInit {
  @Input('selectedItems') selectedItems: Array<any> = [''];
  @Input('fields') fields: Array<any> = [''];
  @Input('disabled') disabled: boolean = false;
  @Input('modalLayer') modalLayer: number = 0;
  @Input('relatedTableId') relatedTableId: any = '';
  @Input('reportKey') reportKey: string | null = null;

  @ViewChild('input', { static: false }) input!: any;
  @ViewChild('select', { static: false }) select!: any;
  @ViewChild('select2', { static: false }) select2!: any;
  @ViewChild('selectSearchScroll', { static: false }) selectSearchScroll!: any;
  @ViewChild('checkbox', { static: false }) checkbox!: any;
  @ViewChild('textarea', { static: false }) textarea!: any;
  @ViewChild('file', { static: false }) file!: any;
  fieldObj:any={};
  PIIData: any = {};
  required = false;
  currentUserEmail: string = '';
  form!: UntypedFormGroup;
  userRole: string = '';
  savedFields: Array<TabData> = [];
  readonlyFieldsValue: any = {};
  fieldsToBeAdded: Array<any> = [];
  applicationTableAllFields: Array<any> = [];
  columnsDataDropdown: any;
  subsink = new SubSink();
  formKey = ''; // kept 0 as default for getFormSavedFields API;
  multiple_values = 'Multiple Values';
  userOptions: Array<any> = [];
  isFormInitiated:boolean = false;
  tableKeyOptions: any = [];
  relatedSingularNames:any = {};
  relatedOptions:any = {};
  syncDataCalled:boolean=false;
  DROPDOWN_VALUE_PLACEHOLDER = DROPDOWN_VALUE_PLACEHOLDER;
  isformSavedfieldsLoading:{[key:string]:boolean} = {};
  

  constructor(
    private action: ActionService,
    private store: Store,
    private route: RouteService,
    private modal: NgbModal,
    private fb: UntypedFormBuilder,
    private alert: AlertService,
    private authService: AuthService,
    private cdr:ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.getApiState();
    this.store.dispatch(
      new LoadFormSavedFields(this.relatedTableId, this.formKey, false,false,'0',this.reportKey)
    );
    this.fields = JSON.parse(JSON.stringify(this.fields));
    this.subsink.add(
    this.store.pipe(select(getApplicationData),filter((data) => !!data[this.route.getApplicationKey()])).subscribe((data)=>{
      if(data && Object.keys(data).length){
        this.tableKeyOptions = data[this.route.getApplicationKey()].Tables.filter((table)=> table.Name !== 'Audit Log')
      }
    }))
    this.fields = this.fields.filter(
      (e: any) =>
        (e.IsFormula === false &&
          e.IsSummaryField === false &&
          e.IsUnique === false &&
          e.IsLookupField === false &&
          e.Name !== 'Record Id' &&
          e.Name !== 'Created By' &&
          e.Name !== 'Modified By' &&
          e.Name !== 'Date Created' &&
          e.Name !== 'Date Modified' &&
          e.FieldType !== 'FILE' &&
          e.FieldType !== 'PII') ||
        e.FieldName?.includes('_related')
    );
    this.loadSubscribers();
  }

  getApiState(){
        const combinedSubscription = combineLatest([
          this.store.pipe(select(getformSavedfieldsLoading)),
        ]).subscribe(([isformSavedfieldsLoading]) => {
          this.isformSavedfieldsLoading = isformSavedfieldsLoading;
        });
        this.subsink.add(combinedSubscription);
    }

  update = () => {
    this.getSyncDataError();
    this.alert
      .fire(<SweetAlertOptions>{
        ...alertPresets.delete,
        title: 'Are you sure?',
        text: 'Bulk edit may circumvent form rules.',
        confirmButtonText: 'Yes, bulk edit',
      })
      .then(async (res: any) => {
        if (res.isConfirmed) {
          const payload = this.getPayload();
          try {
            this.syncDataCalled=true;
            await this.action.dispatch(
              OpTypes.UPDATE,
              new SyncData(this.relatedTableId, payload),
              getFormOperations
            );
            // this.close(true);
          } catch (err) {}
        }
      });
  };

  getPayload() {
    const payload: any = [];
    this.selectedItems.forEach((r: any) => {
      if(!r.colFilter && !r.colSearch){
        let obj: any = [];
        let formValue = this.form.value.FieldsList.filter((field:any)=> field.IsDisabled);
        for (let formField of formValue) {
          const field = this.fields.filter((e) => e.FieldName === formField.Id)[0];
            if(field?.FieldType === 'PII2' && !formField.Value && !field.IsNullable){
              this.alert.toast(
                ToastTypes.ERROR,
                'Update Error',
                `${field.Name} is not nullable`
              );
              return;
            }

            if (
              field?.FieldType === 'ENUM2' &&
              Array.isArray(formField.Value)
            ) {
              obj.push({
                Name: formField.Id.split('_').splice(1).join('_'),
                Info: null,
                Value: formField.Value.sort().join(';'),
                Type: field?.FieldType,
                Base64EncodedFile: '',
              });
            } else if (
              field?.FieldType === 'TINYINT(1)'
            ) {
              if(formField.Value !== null){
                obj.push({
                  Name: formField.Id.split('_').splice(1).join('_'),
                  Info: null,
                  Value: formField.Value,
                  Type: field?.FieldType,
                  Base64EncodedFile: '',
                });
              }
            } else {
              obj.push({
                Name: formField.Id.split('_').splice(1).join('_'),
                Info: null,
                Value: formField.Value,
                Type: field?.FieldType,
                Base64EncodedFile: '',
              });
            }

        }
        payload.push({
          ApplicationTableKey: this.relatedTableId,
          ActionType: 'update',
          FieldsList: obj,
          Where: { Rid: r.id },
        });
      }
    });
    return payload;
  }

  setSelectedValue = (event: any, fg: UntypedFormGroup) => {
    fg.patchValue({ Value: event.value });
  };

  setMultiSelectedValue = (event: any, fg: UntypedFormGroup) => {
    if (event != null && event.length > 0) {
      event.forEach((e: any) => {
        if (e.value === 'click!') {
          let index = event.findIndex((f: any) => f.value === e.value);
          event.splice(index, 1);
        }
      });
    }
    fg.patchValue({ Value: event.value });
  };

  /**
   * Input field type (number, text etc)
   * @param field
   */
  inputFieldType = (field: Column) => {
    switch (field.FieldType) {
      case 'DATETIME':
        return 'datetime-local';
      case 'DATE':
        return 'date';
      case 'INT':
        if (
          field.FieldName === 'datemodified' ||
          field.FieldName === 'datecreated' ||
          datecreatedRegex.test(field.FieldName) ||
          datemodifiedRegex.test(field.FieldName)
        )
          return 'text';
        return 'number';
      case 'FILE':
        return 'file';
      case 'Email':
        return 'email';
      case 'EMAIL':
        return 'email';
      case 'DOUBLE':
        return 'number';
      case 'DECIMAL(20,2)':
        return 'number';
      case 'VARCHAR(255)':
      default:
        if (field.FieldType === 'number') return 'number';
        if (field.GeneralType === 'number') return 'number';
        return 'text';
    }
  };

  /**
   * Input field placeholder
   * @param field
   */
  inputFieldPlaceholder = (field: Column) => {
    switch (field.FieldType) {
      case 'VARCHAR(15)':
        return '(000) 000-0000';
      default:
        this.getFieldValue(field);
        if (this.fieldObj[field.FieldKey]===true) {
          return 'Multiple Values';
        }
        return 'Enter here';
    }
  };

  /**
   * Get mask to set on input field
   * @param col
   */
  inputFieldMask = (col: Column) => {
    if (col.FieldType === 'VARCHAR(15)') return '(000) 000-0000';
    return '';
  };

  columnFilter = (col: any) => {
    if (
      col.FieldName == 'datemodified' ||
      col.FieldName == 'datecreated' ||
      col.FieldName == 'createdby' ||
      col.FieldName == 'modifiedby'
    )
      return false;
    return (
      ((col.IsFormula === col.IsLookupField) === col.IsSummaryField) === false
    );
  };

  isFormActionAllowed = (field: Column) => {
    if (!field.IsFlyAdditionAllowed) return false;
    return true;
  };

  isUserField = (field: Column) => {
    return field.FieldType == 'USER' || (field.IsRelation ? true : false);
  };

  /**
   * Init form
   */
  initForm = () => {
    this.form = this.fb.group({
      FieldsList:this.fb.array([])
    });
    this.fields.forEach((f: any) => {
      (this.form.controls.FieldsList as UntypedFormArray).push(
        this.fb.group({
          Id:f.FieldName,
          Value:new UntypedFormControl(this.getFieldValue(f)),
          IsDisabled:[false],
          FieldKey:f.Key,
        })
      )
    });
    this.isFormInitiated = true;
    this.setFormValidations();
  };

  setFormValidations(){
    this.fields.forEach((f: any) => {
      const isRequired = f.FieldType === 'PII2' && !f.IsNullable;
      if(isRequired){
        const control = this.fieldIdToControl(f.FieldName);
        if (control) {
          control.controls.Value.setValidators(Validators.required);
          control.controls.Value.updateValueAndValidity();
        }
      }
    });
    this.cdr.detectChanges();
  }
  /**
   * @returns form control of corresponding field id
   */
  fieldIdToControl = (fieldKey: string) => {
    const index = (
      this.form.controls.FieldsList as UntypedFormArray
    ).controls.findIndex((group) => group.value.Id == fieldKey);
  // Return undefined if field not found
  if (index === -1) {
    return undefined;
  }
    return (
      (this.form?.controls.FieldsList as UntypedFormArray).at(index) as UntypedFormGroup
    )
  };

  getFieldValue(field: any) {
    this.fieldObj[field.FieldKey] = false;
    if (this.selectedItems.length > 1) {
      const startIndex = (this.selectedItems[0].colFilter || this.selectedItems[0].colSearch) ? 1:0
      for (let i = startIndex+1; i < this.selectedItems.length; i++) {
        if (
          this.selectedItems[startIndex][field.FieldName] !==
          this.selectedItems[i][field.FieldName]
        ){
           this.fieldObj[field.FieldKey]=true;
           return field.FieldType === 'ENUM2'
           ? ''
           : (field.FieldType === 'TINYINT(1)' || field.FieldType === 'VARCHAR(15)') ? null : '';
        }
      }
      return this.returnValue(field,startIndex);
    } else {
      return this.returnValue(field,0);
    }
  }

  returnValue(field:any,index:any){
    if(field.FieldType === 'ENUM2'){
      return this.selectedItems[index][field.FieldName]?.split(';')
    } else if(field.FieldType === 'TINYINT(1)'){
      return this.selectedItems[index][field.FieldName] === 'True' ? 'true' : 'false';
    } else if(field.FieldType === 'DATETIME'){
      return moment(this.selectedItems[index][field.FieldName], 'MM-DD-YYYY hh:mm:ss').format('YYYY-MM-DD hh:mm:ss')
    } else if(field.FieldType === 'DATE'){
      return moment(this.selectedItems[index][field.FieldName], 'MM-DD-YYYY').format('YYYY-MM-DD')
    }
    return this.selectedItems[index][field.FieldName];
  }

  inputTypeSelector = (field: Column) => {
    if(field.IsRelation) return this.selectSearchScroll;
    if (field.DropdownValues && field.FieldType != 'USER') return this.select;
    if (field.LookupTargetFieldKey && field.Name.startsWith('Related'))
      return this.select;
    let type = field.FieldType;
    if (
      field.FieldName === 'createdby' ||
      field.FieldName === 'modifiedby' ||
      createdbyRegex.test(field.FieldName) ||
      modifiedbyRegex.test(field.FieldName)
    )
      type = 'VARCHAR(255)';

    switch (type) {
      case 'FILE':
        return this.file;
      case 'TEXT':
        return this.textarea;
      case 'TINYINT(1)':
        return this.checkbox;
      case 'ENUM':
        return this.select;
      case 'ENUM2':
        return this.select2;
      case 'USER':
        return this.selectSearchScroll;
      case 'INT':
      case 'VARCHAR(255)':
      case 'VARCHAR':
      default:
        return this.input;
    }
  };

  close(data = false) {
    this.modal.dismissAll(data);
  }

  loadSubscribers() {
    this.subsink.add(
      combineLatest([
        this.store.pipe(
          select(getformSavedfields),
          filter(
            (saved) =>
              !!saved[this.relatedTableId] &&
              !!saved[this.relatedTableId][this.formKey]
          ),
          map((saved) => saved[this.relatedTableId][this.formKey])
        ),
      ]).subscribe((data: any) => {
        this.columnsDataDropdown = data?.[0]?.TabData?.[0]?.['Columns'];
        if (!this.isFormInitiated) this.initForm();
        const userFields = this.fields.filter((e) => e.FieldType === 'USER');
        if (userFields.length > 0) {
          this.userOptions = [];
          const field = this.columnsDataDropdown?.filter(
            (c: any) => c.FieldKey === userFields[0].Key
          )[0];
          field?.DropdownValues.forEach((f: any) => {
            this.userOptions.push({
              value: f.Value,
              label: f.Name,
            });
          });
          this.userOptions = this.userOptions.filter(
            (option: any) =>
              option.value !== this.authService.userProfile.Email &&
              option.value
          );
          this.userOptions.unshift({
            value: this.authService?.userProfile?.Email,
            label: 'Current User',
          });
        }
        this.columnsDataDropdown.forEach((column: Column) => {
          if (column.IsRelation && !column.RelatedTableSingularName) {
            const table = this.tableKeyOptions.find(
              (tables: any) => tables.Key === column.RelatedTableKey
            );
            if (table) {
              this.relatedSingularNames[column.Key] = table.SingularReference;
            }
          }
          if (column.IsRelation && column.DropdownValues?.length) {
            let arr: Array<any> = column.DropdownValues.map((ddv: any) => ({
              value: ddv.Value,
              label: ddv.Name,
            }));
            this.relatedOptions[column.FieldKey] = arr;
          }
        });
      })
    );

    this.subsink.add(
      this.store
        .pipe(
          select(getSyncData),
          filter((data: any) => {
            return (
              !!data &&
              !!data[this.relatedTableId]
            );
          }),
          map((data: any) => {
            return data[this.relatedTableId];
          })
        )
        .subscribe((data: SyncDataResponse) => {
          if (data && this.syncDataCalled) {
            this.syncDataCalled=false;
            if (data?.errors > 0) {
              this.close(true);
              const modal = this.modal.open(ErrorComponent, {
                windowClass: 'modal-custom',
                centered: true,
                backdrop: 'static',
                animation: true,
                keyboard: false,
                size: 'lg',
              });
              modal.componentInstance.response = data;
            } else {
              this.close(true);
              this.action.dispatch(
                OpTypes.DELETE,
                new Reset(),
                getFormOperations
              );
            }
          }
        }));
  }
  getDropdownValues(col: Column) {
    const arr: any = [];
    if (col.FieldType === 'ENUM' || col.FieldType === 'ENUM2') {
      const field = this.columnsDataDropdown?.filter(
        (c: any) => c.FieldKey === col.Key
      )[0];
      field?.DropdownValues.filter((option:any) => option.IsActive).forEach((f: any) => {
        arr.push({
          value: f.Value,
          label: f.Name,
        });
      });
    }
    if (col.LookupTargetFieldKey && col.Name.startsWith('Related')) {
      const field = this.columnsDataDropdown?.filter(
        (c: any) => c.Name == col.Name
      )[0];
      field?.DropdownValues.forEach((f: any) => {
        arr.push({
          value: f.Value,
          label: f.Name,
        });
      });
    }
    return arr;
  }

  isFormValid(){
    return this.form.invalid || !(this.form.controls.FieldsList as UntypedFormArray).controls.some(control => (control as UntypedFormGroup).controls.IsDisabled.value === true)
  }

  getSyncDataError(){
    let errorSubject = new Subject();
      this.store.pipe(
        select(getSyncError),
        takeUntil(errorSubject)
      ).subscribe((err)=> {
        if(this.syncDataCalled && err){
          this.syncDataCalled = false
          if ((err as any)?.error?.errors > 0) {
            this.close(true);
            const modal = this.modal.open(ErrorComponent, {
              windowClass: 'modal-custom',
              centered: true,
              backdrop: 'static',
              animation: true,
              keyboard: false,
              size: 'lg',
            });
            modal.componentInstance.response = err.error;
            errorSubject.next();
            errorSubject.complete();
          }
        }
      });
  }

  ngOnDestroy(){
    this.subsink.unsubscribe();
  }

}
